var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6464 7.27923V8.1754M20.6464 11.7601V12.6563M20.6464 16.2409V17.1371M20.6464 20.7218V21.618M9.89234 15.3448H16.1655M9.89234 18.0333H13.477M4.9634 6.38306C4.22137 6.38306 3.61914 6.98528 3.61914 7.72731V11.3431C4.1649 11.6573 4.61822 12.1098 4.93343 12.655C5.24863 13.2002 5.4146 13.8188 5.4146 14.4486C5.4146 15.0784 5.24863 15.697 4.93343 16.2422C4.61822 16.7874 4.1649 17.2399 3.61914 17.5541V21.1699C3.61914 21.9119 4.22137 22.5141 4.9634 22.5141H25.5753C26.3174 22.5141 26.9196 21.9119 26.9196 21.1699V17.5541C26.3738 17.2399 25.9205 16.7874 25.6053 16.2422C25.2901 15.697 25.1242 15.0784 25.1242 14.4486C25.1242 13.8188 25.2901 13.2002 25.6053 12.655C25.9205 12.1098 26.3738 11.6573 26.9196 11.3431V7.72731C26.9196 6.98528 26.3174 6.38306 25.5753 6.38306H4.9634Z",
    stroke: "#4BB869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.a1a1a1ec94f2dfb40f3aa6e73345102a.svg";
export { ForwardRef as ReactComponent };